
import { GEAR_CATEGORIES as SHARED_GEAR_CATEGORIES } from "@/lib/gearCategories";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface UserContactFieldsProps {
  formData: {
    website: string;
    phone: string;
    address: string;
    about: string;
    gearCategory: string;
  };
  role: string;
  isCreating: boolean;
  onInputChange: (field: string, value: string) => void;
}

const GEAR_CATEGORIES = SHARED_GEAR_CATEGORIES.map((category) => ({
  value: category.slug,
  label: category.label,
}));

const UserContactFields = ({ formData, role, isCreating, onInputChange }: UserContactFieldsProps) => {
  return (
    <>
      {(role === 'retail-store' || role === 'builder') && (
        <div className="space-y-2">
          <Label htmlFor="gearCategory">Gear Category *</Label>
          <Select
            value={formData.gearCategory}
            onValueChange={(value) => onInputChange('gearCategory', value)}
            disabled={isCreating}
          >
            <SelectTrigger id="gearCategory">
              <SelectValue placeholder="Select a gear category" />
            </SelectTrigger>
            <SelectContent>
              {GEAR_CATEGORIES.map((cat) => (
                <SelectItem key={cat.value} value={cat.value}>
                  {cat.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}

      <div className="space-y-2">
        <Label htmlFor="about">About</Label>
        <Textarea
          id="about"
          value={formData.about}
          onChange={(e) => onInputChange('about', e.target.value)}
          placeholder="About this user or business"
          disabled={isCreating}
          className="min-h-[160px]"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="website">Website</Label>
        <Input
          id="website"
          type="url"
          value={formData.website}
          onChange={(e) => onInputChange('website', e.target.value)}
          placeholder="https://www.example.com"
          disabled={isCreating}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="phone">Phone Number</Label>
        <Input
          id="phone"
          type="tel"
          value={formData.phone}
          onChange={(e) => onInputChange('phone', e.target.value)}
          placeholder="Enter phone number"
          disabled={isCreating}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="address">Address</Label>
        <Textarea
          id="address"
          value={formData.address}
          onChange={(e) => onInputChange('address', e.target.value)}
          placeholder="Enter full address"
          disabled={isCreating}
          className="min-h-[80px]"
        />
      </div>
    </>
  );
};

export default UserContactFields;
